// extracted by mini-css-extract-plugin
export default {"arrowIconWrap":"enter_arrowIconWrap__D5Ksk"};